import request from '../../shared/request'

export function getItemList() {
  return request('/item')
}

export function getAllItems() {
  return request(`/item/`)
}

export function printItems(queryString) {
  return request(`/item/print${queryString}`)
}

export function getVendorItems(vendorId) {
  return request(`/item/${vendorId}/vendors_item`)
}

export function getItemVendors(itemId) {
  return request(`/item/${itemId}/items_vendor`)
}

export function getItemImages(item_id) {
  return request(`/item/${item_id}/images`)
}

export function saveItemImage(payload) {
  return request(`/item/${payload.item_id}/images`, {
    method: 'POST',
    body: payload.form_data,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteItemImage(payload) {
  return request(`/item/${payload.image_id}/images`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteItemVendor(payload) {
  return request(
    `/item/vendor?organization_id=${payload.organization_id}&item_id=${payload.item_id}`,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      }
    }
  )
}

export function createNewItem(payload) {
  return request(`/item/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function createNewItemVendor(payload) {
  return request(`/item/vendor`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateSavedItem(payload) {
  return request(`/item/${payload.item_id}`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteItem(payload) {
  return request(`/item/${payload.itemId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

// notes
export function fetchItemNote(payload) {
  return request(`/item/${payload.itemId}/notes`)
}

export function createItemNote(payload) {
  return request(`/item/${payload.itemId}/notes`, {
    method: 'POST',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function editItemNote(payload) {
  return request(`/item/${payload.noteId}/notes`, {
    method: 'PUT',
    body: payload,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function deleteItemNote(payload) {
  return request(`/item/${payload.noteId}/notes`, {
    method: 'DELETE',
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/item.js